import React, { useState, useEffect } from 'react';
import {  useDispatch, useSelector } from 'react-redux';
import {  CELL_RENDERERS, Table, TABLE_LAYOUT_OPTIONS, Loader, Dialog } from 'cdk-radial';
import Overlay from '../../../Overlay/Overlay';
import './PendingSubscriptionsTable.scss';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import config from '../../../../utils/config';
import { getLatestDate, dateComparator,onGridReady } from '../common';
import AuthComponent from '../../../common/AuthComponent';
import CancelSubscriptionOverlayContent from './CancelSubscriptionOverlayContent';
import { getSolutionSubscriptionInfo, getEntityById } from '../../../../redux/connectedComponent/subscriptionManagement/subscriptionManagement.slice';
import { clearPendingLocations, cancelSubscription } from '../../../../redux/connectedComponent/subscriptionManagement/cancelSubscription.slice';
import Notification from '../../../notification/Notification';
import { modifyStr } from '../../../../utils/utils';
import ShowLocations from '../ShowLocations';
import CustomMenu from './CustomMenu';
import { AppLink } from '../utils/AppLink';
import { sendAmplitudeData } from '../../../../utils/amplitude';
import { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES } from '../../../../constants/amplitudeConstants';

const CUSTOM_STYLE = {
  width: "550px",
  maxHeight: "315px"
};

const SAVE = 'Save';
const SAVING = 'Saving...';
const COLOR_STROKE = 'rgba(21,27,37,0.4)';
const POSITIVE = 'positive';
const NEGATIVE = 'negative';

const PendingSubscriptionsTable = ({pendingTableLayout, checkPendingTablePagination, searchInput}) => {

  const renderMenu = gridParams => {
    return <CustomMenu
    gridParams={gridParams}
    />
  };

  const renderShowLocations = gridParams => {
    return <ShowLocations gridParams={gridParams} />
  }

  const dispatch = useDispatch();

  const state = useSelector(state => state);
  const pendingSubscriptions = state.subscriptionManagementSlice.pendingSubscriptions;
  const solutionSubscriptionInfo = state.subscriptionManagementSlice.solutionSubscriptionInfo;
  const fetchingSubscriptions = state.subscriptionManagementSlice.fetchingSubscriptions;
  const cancelSubscriptionPending = state.cancelSubscriptionSlice.cancelSubscriptionPending;
  const cancelSubscriptionError = state.cancelSubscriptionSlice.cancelSubscriptionError;
  const cancelSubscriptionSuccessful = state.cancelSubscriptionSlice.cancelSubscriptionSuccessful;
  const locationsToCancelSubscription = state.cancelSubscriptionSlice.locationsToCancelSubscription;
  const token = state.loginDetailsSlice.authenticationToken;
  const allLocations = state.loginDetailsSlice.allLocations;
  const userEmail = state.loginDetailsSlice.userEmail;
  const appProvider = state.subscriptionManagementSlice.appProvider;

  const [pendingSubscriptionsData, setPendingSubscriptionsData] = useState([]);
  const [pendingEntities, setPendingEntities] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [disableSave, setDisableSave] = useState(true);
  const [showNotification, setShowNotification] = useState(false);
  const [solutionName, setSolutionName] = useState('');
  const [notificationContent, setNotificationContent] = useState(false);
  const [notificationType, setNotificationType] = useState(false);
  const [solutionId, setSolutionId] = useState('');
  const [publisherName, setPublisherName] = useState('');
  const [clickedApp, setClickedApp] = useState('');
  const [clickedAppId, setClickedAppId] = useState('');
  const [isAppNotListed, setIsAppNotListed] = useState(false);

  useEffect(()=>{
    dispatch(clearPendingLocations());
  },[]);

  const goToMarketplace = (orgId, appName, appId) => {
    if (appName) {
      dispatch(getEntityById({ orgId, token }));
      setClickedApp(appName);
      setClickedAppId(appId);
    }
    else{
      setIsAppNotListed(true);
    }
  }


  const column = [
    {
      cellRendererFramework: AppLink,
      field: 'appName',
      headerName: 'App Name',
      width: 400,
      minWidth: 400,
      cellRendererParams: {
        goToMarketplace
      }
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'method',
      headerName: 'Method',
      width: 120,
      minWidth: 120
    },
    {
      cellRendererFramework: renderShowLocations,
      field: 'location',
      headerName: 'Location(s)',
      width: 110,
      minWidth: 110
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'publisher',
      headerName: 'Publisher',
      width: 270,
      minWidth: 270
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'subscribedOn',
      headerName: 'Subscribed/Activated On',
      width: 190,
      minWidth: 190,
      sortable: true,
      unSortIcon: true,
      comparator: dateComparator
    },
    {
      cellRendererFramework: renderMenu,
      field: 'pendingAccountInfo',
      headerName: '',
      width: 100,
      minWidth: 100,
      comparator: dateComparator
    },

  ];

  const handleCancelSubscription = (subscription, solutionData) => {

    const id = solutionData.id;
    let name, publisherName;

    if (solutionData.isAppNotListed) {
      name = solutionData.displayName;
      publisherName = solutionData.orgName;
    } else {
      let { overview } = solutionData;
      name = overview.name;
      publisherName = overview.publisherName;
    }
    dispatch(clearPendingLocations());
    const entities = [];
    subscription && subscription.map(item => {
      let entityInfo = allLocations.find(loc => {return loc.entityId === item.entityId});
      entities.push({
        solutionId: item.solutionId,
        entityId: item.entityId,
        entityName: entityInfo.partyName
      });
    });
    setPendingEntities(entities);
    setOpenDialog(true);
    setSolutionName(name);
    setSolutionId(id);
    setPublisherName(publisherName);
  };

  useEffect(()=>{
    if(locationsToCancelSubscription.length){
      setDisableSave(false);
    } else {
      setDisableSave(true);
    }
  },[locationsToCancelSubscription]);

  function onOverlayClose(){
    sendAmplitudeData(AMPLITUDE_EVENTS.CLOSE_CANCEL_SUBSCRIPTION,{
      [AMPLITUDE_PROPERTIES.APP_ID]: solutionId,
      [AMPLITUDE_PROPERTIES.APP_NAME]: solutionName,
     })
    setOpenDialog(false);
  }

  function onOverlayAccept(){
   sendAmplitudeData(AMPLITUDE_EVENTS.CANCEL_SUBSCRIPTION,{
    [AMPLITUDE_PROPERTIES.APP_ID]: solutionId,
    [AMPLITUDE_PROPERTIES.APP_NAME]: solutionName,
    [AMPLITUDE_PROPERTIES.LOCATION_COUNT]: locationsToCancelSubscription?.length,
    [AMPLITUDE_PROPERTIES.LOCATIONS]: locationsToCancelSubscription.map(loc => 
      ({
        [AMPLITUDE_PROPERTIES.ORG_ID]: loc?.entityId,
        [AMPLITUDE_PROPERTIES.ORG_NAME]: loc?.entityName,
      }))
   })
    dispatch(cancelSubscription({pendingEntities: locationsToCancelSubscription, token, shouldDeleteMarketplaceRecords: true}));
  }

  useEffect(()=>{
    if(cancelSubscriptionError) {
      setOpenDialog(false);
      setNotificationContent('Failed to cancel subscriptions. Please try again.');
      setNotificationType(NEGATIVE);
      setShowNotification(true);
    }
    else if(cancelSubscriptionSuccessful) {
      setOpenDialog(false);
      setNotificationContent(
        `You removed ${locationsToCancelSubscription.length} pending location(s) from your ${solutionName} subscription`
      );
      setNotificationType(POSITIVE);
      setShowNotification(true);
    }

  },[cancelSubscriptionError, cancelSubscriptionSuccessful]);


useEffect(() => {
  if(appProvider && clickedApp && clickedAppId) {
    let provider = modifyStr(appProvider.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-').toLowerCase());
    let appName = modifyStr(clickedApp.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-').toLowerCase());
    window.open(`${config.url.marketplace}solutions/${provider}/${appName}?id=${clickedAppId}`);
    setClickedApp('');
    setClickedAppId('');
  }
}, [appProvider]);


  useEffect(()=>{
    let item = null;
    let pendingData = [];

    if(pendingSubscriptions){
      map(pendingSubscriptions, (subscription, index) => {
        let isPendingAccountVerification = false;
        let pendingOrgInfo = null;
        let  isBulkSubscribed = subscription.filter(sub => sub.isBulkSubscribed ).length>0;
        if(solutionSubscriptionInfo[index]){
          item = {
            appName: solutionSubscriptionInfo[index]?.overview?.name || solutionSubscriptionInfo[index].displayName,
            location: subscription.length,
            publisher: solutionSubscriptionInfo[index]?.overview?.publisherName || solutionSubscriptionInfo[index].orgName,
            subscribedOn: getLatestDate(subscription),
            solutionData: solutionSubscriptionInfo[index],
            handleCancelSubscription: handleCancelSubscription,
            subscriptionData: subscription,
            method: isBulkSubscribed ? 'Fortellis Admin'  : (solutionSubscriptionInfo[index].activateOnly!==false ? 'Activation' : 'Subscription'),
            isBulkSubscribed: isBulkSubscribed,
            rowHeight: 52,
            solutionLogo: solutionSubscriptionInfo[index]?.overview?.solutionLogo,
            orgId: solutionSubscriptionInfo[index]?.orgId,
            appId: solutionSubscriptionInfo[index]?.id,
            privacyProtection: solutionSubscriptionInfo[index]?.privacyProtection
          };

          // check is pending account verification
          subscription.map(({pendingAccountVerification, solutionId, entityId,customerRef}) => {
            if(pendingAccountVerification){
              isPendingAccountVerification = true
              pendingOrgInfo = {solutionId, entityId,customerRef}
            }
            return true
          })

          if (isPendingAccountVerification){
            item.pendingAccountInfo = {
              isPendingAccountVerification,
              pendingOrgInfo
            }
          }
          pendingData.push(item);
        }
      });
      setPendingSubscriptionsData(pendingData);
    }
  },[pendingSubscriptions,solutionSubscriptionInfo]);

  useEffect(()=>{
    if(fetchingSubscriptions){
      setPendingSubscriptionsData([]);
    }
  },[fetchingSubscriptions]);

  const getRowHeight = params => params.data.rowHeight;

  return (
    <div>
        <div className={pendingTableLayout === TABLE_LAYOUT_OPTIONS.NORMAL ? 'pending_table' : 'pending-table_no-pagination'}>
          <Table
            columns={column}
            data={pendingSubscriptionsData?.filter(data => searchInput ? data?.appName?.toLowerCase()?.includes(searchInput.toLowerCase()) || data?.publisher?.toLowerCase()?.includes(searchInput?.toLowerCase()) : true)}
            getRowHeight={getRowHeight}
            hasPagination={checkPendingTablePagination}
            isSearchable={false}
            isDownloadable={false}
            isPrintable={false}
            resizableHeaders={false}
            showNoRowsOverlay={false}
            showFooter={false}
            hideTableTitle={true}
            hideTableHeader={true}
            tableLayout={pendingTableLayout}
            id="table-with-auto-height-1"
            noRowsFoundMessage='Looks like you could use a few App subscriptions to manage'
            onGridReady={onGridReady}
            sortingOrder={['asc', null, 'desc']}
            />
        </div>
        <Overlay
          active={openDialog}
          title={'Cancel Pending Location(s)'}
          onOverlayClose={onOverlayClose}
          customeStyle={CUSTOM_STYLE}
          onOverlayAccept={onOverlayAccept}
          hideFirstButton={true}
          secondButtonText={cancelSubscriptionPending ? <Loader label={SAVING} style={{stroke: COLOR_STROKE}}/> : SAVE}
          className='cancel-pending-location-overlay'
          disableSecondButton={disableSave || cancelSubscriptionPending}
          >
            <CancelSubscriptionOverlayContent
              pendingEntities={pendingEntities}
            />
        </Overlay>
        {
        showNotification &&
          <Notification
            content={notificationContent}
            variant={notificationType}
            actions={[{"text":"Dismiss"}]}
            onDismiss={() => {
              setShowNotification(false);
              dispatch(clearPendingLocations());
              if(cancelSubscriptionSuccessful) {
                const entityIds = uniq(allLocations.map(item => item.entityId));
                dispatch(getSolutionSubscriptionInfo({entityIds,token}));
              }
            }}
            customStyle={{ marginTop: '70px' }}
          />
      }
      <Dialog
       isOpen={isAppNotListed}
       dataTestId="restricted-subscription-management-dialog"
       hideCloseButton={false}
       onClose={() => setIsAppNotListed(false)}
       id="overlay-id"
       closeLabel="Close"
       title = 'App has been removed from Marketplace'
      >
       This app is no longer available in Marketplace. Contact the Publisher for more details.
      </Dialog>
    </div>
  );
}

export default AuthComponent(PendingSubscriptionsTable);
